import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X, ArrowUpRight, Phone } from "lucide-react";
import { scrollToSection } from "@/lib/scroll";
import { whatsappUrl, CALL_URL } from "@/data/company";

const LINKS = [
  { label: "Origins", id: "origins" }, { label: "Process", id: "process" },
  { label: "Collection", id: "products" }, { label: "CNC", id: "cnc-patterns" },
  { label: "Gallery", id: "gallery" }, { label: "Reviews", id: "reviews" }, { label: "Contact", id: "contact" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const close = (event) => { if (event.key === "Escape") setOpen(false); };
    window.addEventListener("keydown", close);
    return () => window.removeEventListener("keydown", close);
  }, []);
  const go = (id) => {
    setOpen(false);
    if (location.pathname === "/" && location.hash === `#${id}`) scrollToSection(`#${id}`);
  };

  return (
    <header className="fixed top-0 inset-x-0 z-50 border-b border-bone/10 bg-ink/85 backdrop-blur-xl" data-testid="navbar">
      <div className="relative flex items-center justify-between px-6 md:px-12 h-16">
        <nav className="hidden xl:flex items-center gap-5" aria-label="Primary" data-testid="desktop-navigation">
          {LINKS.map((link) => <Link key={link.id} to={`/#${link.id}`} onClick={() => go(link.id)} data-testid={`nav-${link.id}-link`} className="text-[11px] uppercase font-heading font-medium text-bone/60 transition-colors duration-300 hover:text-bone">{link.label}</Link>)}
        </nav>
        <button className="xl:hidden text-bone p-2 -ml-2 transition-colors hover:text-copper" onClick={() => setOpen(!open)} aria-label={open ? "Close menu" : "Open menu"} aria-expanded={open} aria-controls="mobile-navigation" data-testid="mobile-menu-button">{open ? <X size={22} /> : <Menu size={22} />}</button>
        <Link to="/#top" onClick={() => go("top")} className="absolute left-1/2 -translate-x-1/2" aria-label="Garg Stone Company — home" data-testid="nav-logo">
          <img src="/catalog/logo.png" alt="Garg Stone Company — Since 1988" className="h-10 md:h-11 w-auto max-w-[180px] object-contain" data-testid="nav-logo-img" />
        </Link>
        <a href={whatsappUrl()} target="_blank" rel="noopener noreferrer" data-testid="nav-quote-button" className="hidden xl:inline-flex items-center gap-2 border border-bone/25 px-5 py-2 text-xs uppercase font-heading font-medium transition-colors duration-300 hover:bg-bone hover:text-ink">Get a Quote <ArrowUpRight size={14} /></a>
        <a href={CALL_URL} className="xl:hidden p-2 -mr-2 transition-colors hover:text-copper" aria-label="Call Garg Stone Company" data-testid="nav-call-button"><Phone size={19} /></a>
      </div>
      <AnimatePresence>
        {open && <motion.nav id="mobile-navigation" initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.3 }} className="xl:hidden overflow-hidden border-t border-bone/10 bg-ink" aria-label="Mobile" data-testid="mobile-navigation">
          <div className="flex flex-col px-6 py-6 gap-5">
            {LINKS.map((link) => <Link key={link.id} to={`/#${link.id}`} onClick={() => go(link.id)} data-testid={`mobile-nav-${link.id}-link`} className="text-left text-xl font-heading font-bold uppercase text-bone/80 transition-colors duration-300 hover:text-copper">{link.label}</Link>)}
          </div>
        </motion.nav>}
      </AnimatePresence>
    </header>
  );
};

export default Navbar;